import React, { useEffect } from "react";
import { Row, Col, Container } from "react-bootstrap";
import { TablePage } from "./TablePage";
import Data from "../dummy-data.json";
import BreadCrum from "../pages/BreadCrum";
import { LinkContainer } from "react-router-bootstrap";
import { useDispatch } from "react-redux";
import { fetchTickets } from "../TicketAction";
export const Dashboard = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchTickets());
  }, [dispatch]);

  return (
    <Container>
      <Row>
        <Col md="auto">
          <h4>Dashboard</h4>
          <BreadCrum Data={"Dashboard"} />
        </Col>
        <LinkContainer to="/addticket">
          <button btn>Add Ticket</button>
        </LinkContainer>
      </Row>
      <Col>Total Ticket - 50 </Col>
      <Col>Pending Ticket - 50</Col>
      <Row>
        <Col>
          <TablePage Data={Data} />
        </Col>
      </Row>
    </Container>
  );
};
